import { apiNoAuth } from "./conection";
export const productsServices = {
  // Products
  getProducts: async ({ page = 1, limit = 10, search = "" } = {}) => {
    try {
      const response = await apiNoAuth.get("/products/", {
        params: { page, limit, search },
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      throw error;
    }
  },

  getProductById: async (id) => {
    try {
      const response = await apiNoAuth.get(`/products/by-id/${id}`);
      console.log(response);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar produto:", error);
      throw error;
    }
  },

  async getProductsByCategory(categoryId, { page, limit }) {
    try {
      const url = `/products/category/${categoryId}?page=${page}&itemsPerPage=${limit}`;

      const response = await apiNoAuth.get(url);

      return response.data;
    } catch (parseError) {
      console.error("❌ Erro ao fazer JSON.parse:", parseError.message);
      throw new Error("Resposta da API não é JSON válido");
    }
  },

  async getProductsByDepartament(departmentId, { page, limit }) {
    try {
      const url = `/products/department/${departmentId}?page=${page}&itemsPerPage=${limit}`;

      const response = await apiNoAuth.get(url);

      return response.data;
    } catch (parseError) {
      console.error("❌ Erro ao fazer JSON.parse:", parseError.message);
      throw new Error("Resposta da API não é JSON válido");
    }
  },
  async getProductsByRecent(limit = 10) {
    try {
      const response = await apiNoAuth.get("/products/recents", {
        params: { limit },
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar produtos recentes:", error);
      throw error;
    }
  },
  getProductsSearch: async ({ page = 1, limit = 10, search = "" } = {}) => {
    try {
      const response = await apiNoAuth.get("/products/search", {
        params: { page, limit, search },
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      throw error;
    }
  },
};
